import { render, staticRenderFns } from "./ForEmployerEmailVerification.vue?vue&type=template&id=2ed3f4c2&"
import script from "./ForEmployerEmailVerification.vue?vue&type=script&lang=js&"
export * from "./ForEmployerEmailVerification.vue?vue&type=script&lang=js&"
import style0 from "./ForEmployerEmailVerification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports